module.exports = __webpack_public_path__ + "static/media/arrotek.560322cd.png";